import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../../Styles/CategoryStyles.css'; // Adjust the path as necessary
import StoreItemList from './StoreItemList';
interface ManageStoreItemProps {
  editCategory: () => void;
  modal: boolean;
}

const ManageStoreItem: React.FC<ManageStoreItemProps> = () => {
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);

  const handleEditCategory = () => {
    setModal(true);
  };

  return (
    <Box>
        <>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            {t('storeItem.title')}
          </Typography>
          <StoreItemList editCategory={handleEditCategory} modal={modal}/>
        </>
    </Box>
  );
};

export default ManageStoreItem;  
